import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import React from "react";
import PropTypes from "prop-types";


const UserFilter = ({filterParam, setFilterParam, onSubmit, onClear}
) => {


    return  <form onSubmit={(e) => onSubmit(e)}>
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-6 p-md-3 hiddenInput">
                <label htmlFor="q">
                    Телефон/ФИО/БИН/Наименование компании
                </label>
                <InputText
                    id="q"
                    name="q"
                    value={filterParam.q || ""}
                    onChange={(e) => setFilterParam({...filterParam, q: e.target.value})}
                />
            </div>
        </div>
        <div className="p-grid p-justify-end">
            <div className="p-mr-2">
                <Button type="submit" label="Найти" autoFocus />
            </div>
            <div className="p-mr-2">
                <Button
                    className="p-button-warning"
                    label="Сбросить"
                    onClick={(e) => onClear(e)}
                />
            </div>
        </div>
    </form>
}

UserFilter.propTypes = {
    filterParam: PropTypes.object.isRequired,
    setFilterParam: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default UserFilter;